<div
	class="bp-button builder-cover-bg"
	[style.background-color]="data.bg_color"
	[style.background-image]="data.hide_bg_image || !data.bg_thumbnail ? '' : ('url(' + data.bg_thumbnail.url + ')')"
>
	<div
		class="bp-page-button builder-default-layout"
		[style.text-align]="data.page_button.align ? data.page_button.align : 'inherit'"
		[style.max-width]="desktopWidth + 'px'"
	>
		<a
			class="button"
			[href]="data.page_button.url"
			[attr.target]="data.is_new_tab ? '_blank' : null"
			[style.background-color]="data.page_button.color ? data.page_button.color : 'initial'"
			[style.width]="data.page_button.width ? data.page_button.width + 'px' : 'auto'"
			[class.block]="data.page_button.width ? false : data.page_button.is_blocked"
			[class.small]="data.page_button.is_small"
			[class.large]="data.page_button.is_large"
			[class.medium]="data.page_button.is_medium"
			[class.x-large]="data.page_button.is_xlarge"
			[class.x-small]="data.page_button.is_xsmall"
			[style.color]="data.page_button.txt_color"
			[style.font-size]="data.page_button.txt_size ? data.page_button.txt_size + 'px' : 'inherit'"
		>
			{{ data.page_button.text }}
		</a>
	</div>
</div>